<template>
    <main>
        <div class="banner">
            <div class="w-50 image" >
                <img src="/images/healthcare2.jpg" alt="" data-aos="zoom-out-up">
            </div>
            <div class="w-50 content">
                <p class="subtitle" data-aos="fade-up" data-aos-delay="100"><strong>
                        <span v-if="selectedLang() == 'en'">WHAT WE DO</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">ماذا نفعل</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">چی دەکەین </bdo></span>
                    </strong></p>
                <p class="title" data-aos="fade-up" data-aos-delay="200">
                    <span v-if="selectedLang() == 'en'">kurdos <span style="white-space: nowrap;">
                            infrastructure</span></span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl"> بنية کوردوس </bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ژێرخانی کوردۆس</bdo></span>
                </p>
                <p class="text text1" data-aos="fade-up" data-aos-delay="300">
                    <span v-if="selectedLang() == 'en'">Kurdos Infra offers Turnkey Solutions for Healt hcare Projects,
                        be it Green Field,
                        Brown Field,
                        upgradation of existing Hospitals, Operation Theatre Complex , Medical Gas Pipeline
                        Systems etc. Kurdos Infra along wit hour <strong> Strategic Partner HE.AR.T </strong>, an
                        exclusive
                        Healthcare Architecture firm, provide services starting from <strong> Concept Master plan,
                            programming, planning & architectural design of hospital to crystallization of Hospital
                            operations, Man Power Planning and Medical Equipment Planning. </strong></span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تقدم شركة كردوس إنفرا حلولاً متكاملة لمشاريع
                            الرعاية الصحية، سواءً كانت مشاريع قيد الإنشاء أو التطوير، أو تطوير المستشفيات القائمة، أو
                            مجمع غرف العمليات، أو أنظمة أنابيب الغاز الطبي، وغيرها. بالتعاون مع شريكها الاستراتيجي
                            HE.AR.T، وهي شركة معمارية متخصصة في مجال الرعاية الصحية، تقدم كردوس إنفرا خدماتها بدءًا من
                            وضع المخطط العام، والبرمجة، والتخطيط، والتصميم المعماري للمستشفيات، وصولًا إلى بلورة
                            عملياتها، وتخطيط القوى العاملة، وتخطيط المعدات الطبية.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">کوردۆس ئینفرا چارەسەری کلیلی دەست بۆ پڕۆژەکانی
                            چاودێری تەندروستی پێشکەش دەکات، جا چ گرین فیڵد بێت،
                            براون فیڵد، ٢٠١٩.
                            نوێکردنەوەی نەخۆشخانەکانی ئێستا، کۆمەڵگەی شانۆی نەشتەرگەری , بۆری غازی پزیشکی
                            سیستەمەکان و هتد کوردۆس ئینفرا بە درێژایی لەگەڵ کاتژمێر هاوبەشی ستراتیژی HE.AR.T ,
                            تایبەتمەندێک
                            کۆمپانیای تەلارسازی چاودێری تەندروستی، خزمەتگوزاری پێشکەش دەکات لە ماستەرپلانی چەمکەوە دەست
                            پێدەکات،
                            بەرنامەسازی، پلاندانان و دیزاینی تەلارسازی نەخۆشخانە بۆ کریستاڵکردنی نەخۆشخانە
                            کارەکان، پلاندانانی هێزی پیاو و پلاندانانی ئامێری پزیشکی.</bdo></span>


                </p>
                <p class="text text2" data-aos="fade-up" data-aos-delay="400">
                    <span v-if="selectedLang() == 'en'" > We also provide
                        <strong> Clinical Interior Design services and Medical Engineering design services </strong>
                        thereby
                        ensuring seamless integration of Building Services and Interiors of the Hospital.</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">كما نقدم أيضًا خدمات التصميم الداخلي السريري
                            وخدمات تصميم الهندسة الطبية، مما يضمن التكامل السلس بين خدمات المباني والتصميمات الداخلية
                            للمستشفى.</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">هەروەها ئێمە خزمەتگوزاری دیزاینی ناوەوەی کلینیکی
                            و خزمەتگوزاری دیزاینی ئەندازیاری پزیشکی پێشکەش دەکەین
                            دڵنیابوون لە یەکخستنی بێ کێشە لە خزمەتگوزارییەکانی بیناسازی و ناوەوەی
                            نەخۆشخانەکە.</bdo></span>

                </p>
            </div>
        </div>
        <div class="products">
            <div class="product" v-for="i in products" :key="i" data-aos="fade-up">
                <div class="product-image">
                    <img :src="i.image" alt="">
                </div>
                <div class="content2">
                    <p>{{ i.name }}</p>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import { ref } from 'vue'
import { selectedLang } from '../../utils/selected_lang';

const products = ref([
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-102.png',
        name: 'Medical Gas pipeline system - Design, Supply & Execution'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-104.png',
        name: 'Modular Operation Theatre - Design, Supply & Execution'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-108.png',
        name: 'Kitchen - Design, Supply & Execution'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-110.png',
        name: 'Laundry - Design, Supply & Execution'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-114.png',
        name: 'Operation Theatre Lights'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-116.png',
        name: 'Operation Theatre Tables'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-126.png',
        name: 'Acoustical Anti Microbial & Metal Ceiling'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-128.png',
        name: 'Acoustical Anti Microbial & Metal Ceiling'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-132.png',
        name: 'Vynil & Rubber anti-static and anti-microbial Flooring'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-134.png',
        name: 'Vynil & Rubber anti-static and anti-microbial Flooring'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-138.png',
        name: 'Hermetically Sealed Doors'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-140.png',
        name: 'Hermetically Sealed Doors'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-144.png',
        name: 'Welcome and waiting area'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-146.png',
        name: 'Welcome and waiting area'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-150.png',
        name: 'Patient room'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-152.png',
        name: 'Nurse station'
    },

    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-156 (1).png',
        name: 'Laboratory'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-158.png',
        name: 'Consultation Room'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-162.png',
        name: 'Seminar Hall & Cafeteria Spaces'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-164.png',
        name: 'Seminar Hall & Cafeteria Spaces'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-168.png',
        name: 'Executive rooms & Administrative areas'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-172.png',
        name: 'CME'
    },
    {
        image: '/healthcare_images/infra/KURDOS-HEALTHCARE-TAB (1).pdf-image-174.png',
        name: 'Library'
    }
])


</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}

.title{
    line-height: 2.1rem !important;
}

main {
    /* color: #073762 !important;  */
    background: #F6F8FB;
    padding: 50px 100px;

}

.dark main {
    background: #131313;
    color: white !important;
}
.dark .banner{
    background: #323232;
}
.dark .content p, .dark .title{
    color: white;
}
.dark .product{
    background: #323232;
}
.dark .content2 p{
    color: #fff !important;
}

.banner {
    display: flex;
    background: white;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    margin-bottom: 56px;
}

.w-50 {
    width: 50%;
}

.image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
}

.content {
    padding: 50px;
}

.title,
.subtitle {
    
    text-transform: uppercase;
    margin-bottom: 20px;
}

.subtitle {
    color: #E43D34 !important;
    font-size: 18px !important;
}

.title {
    color: #073762;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 15px;
}

.content p {
    color: #073762;
}

.products {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
}

.product {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s ease;
    padding: 10px;
}

.product:hover {
    transform: translateY(-5px);
}

.product-image {
    width: 100%;
    height: 220px;
    overflow: hidden;
    border-radius: 10px;
}

.product-image img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.content2 {
    padding: 1rem;
    text-align: center;
}

.content2 p {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: #073762 !important;
}


@media (max-width: 768px) {
    main {
        padding: 20px;
    }

    .banner {
        flex-direction: column;
    }

    .w-50 {
        width: 100%;
    }

    .content {
        padding: 20px;
    }
}
</style>